import { CSApiService } from "../../redux-store/CSApiService";
import { T_ApiResponse } from "../../globalTypes/GlobalTypes";
import {
  T_CaseDetails,
  CustomerRequest,
  T_ReportingServiceResponse,
  T_ReportingService_RequestData,
  T_PaymentRequest,
  T_CaseCreateRequest,
  T_CaseCreateResponse,
  T_OrderStatusRequest,
  T_OrderStatusResponse,
  T_CreateOrderRequest,
  T_CreateOrderResponse,
  T_HlCreateCaseApiRequest,
  T_HlReportingServiceApiRequest,
  T_HlCreateCaseApiPayload,
  T_HlReportingServiceApiPayload,
  T_HlDataServiceApiResponse,
  T_HlDataServiceApiRequest,
  T_HlFetchLanApiRequest,
  T_HlServiceRequestResponse,
  T_HlCreateCaseQueryRequest,
  T_FetchLanDetails_Response,
  T_CreateCaseAPIResponse,
  T_CreateCaseAPIRequest,
  T_EmailChangeRequest,
  T_EmailChangeResponse,
  T_WelcomeKitDownloadResponse,
  T_HlCustomerInfoRequest,
  T_HlCustomerInfoResponse,
  T_HlCreateCaseQueryMultipleRequest,
  T_FetchHLEmailCount_Request,
  T_FetchHLEmailCount_Response,
  T_SaveHomeLoanFaqDetails_Response,
  T_SaveHomeLoanFaqDetails_Request,
  T_AdvanceEMIPaymentDetail_Response,
  T_AdvanceEMIPaymentDetail_Request,
  T_FetchHLRoiHistory_Response,
  T_FetchHLRoiHistory_Request,
  T_CreateCaseRoiHistory_Request,
  T_CreateCaseRoiHistory_Response,
  T_HFL_Otp_Service_Response,
  T_HFL_Generate_Otp_Request,
  T_HFL_Validate_Otp_Request,
  T_FetchPDDInformation_Response,
  T_FetchPDDInformation_Request,
  T_CreateCasePdd_Response,
  T_CreateCasePdd_Request,
  T_Fetch_HomeLoanIdentifier_Request,
  T_Fetch_HomeLoanIdentifier_Response,
  T_CreateCaseReKyc_Response,
  T_CreateCaseReKyc_Request,
} from "./Homeloan_Types";
import {
  Api_Dataservice,
  Api_Fetchlan,
  Api_ReportingService,
  Api_Create_Order,
  Api_Order_Status,
  Api_Create_Case_Query_Multiple,
  Api_Create_Case_Query,
  Api_ChangeEmail,
  Api_WelcomeKitService,
  Api_Customer_Info,
  Api_CreateCase,
  Api_FetchHLEmailCount,
  Api_FetchHLAdvanceEMI_Payment_Detail,
  Api_FetchHLRoiHistory,
  Api_HomeLoan_Generate_Otp,
  Api_HomeLoan_Validate_Otp,
  Api_Fetch_PDD_Information,
  HomeLoanIdentifier,
} from "../../utils/ApiEndpoints";
import dayjs from "dayjs";
import { nanoid } from "@reduxjs/toolkit";

export const HomeloanApi = CSApiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchDataServiceDetails: builder.query<
      T_ApiResponse<T_HlDataServiceApiResponse>,
      T_HlDataServiceApiRequest
    >({
      query: (dataServiceReq) => ({
        url: Api_Dataservice,
        method: "POST",
        body: dataServiceReq,
      }),
    }),
    fetchLanDetails: builder.query<
      T_ApiResponse<T_FetchLanDetails_Response>,
      T_HlFetchLanApiRequest
    >({
      query: (dataServiceReq) => ({
        url: Api_Fetchlan,
        method: "POST",
        body: dataServiceReq,
      }),
    }),

    getCreateCaseDetails: builder.query<
      T_ApiResponse<T_HlCreateCaseApiPayload>,
      T_HlCreateCaseApiRequest
    >({
      query: (payload) => ({
        url: Api_CreateCase,
        method: "POST",
        body: payload,
      }),
    }),

    createCaseAPI: builder.query<
      T_ApiResponse<T_CreateCaseAPIResponse>,
      T_CreateCaseAPIRequest
    >({
      query: (payload) => ({
        url: Api_CreateCase,
        method: "POST",
        body: payload,
      }),
    }),
    getReportingServiceDetails: builder.query<
      T_ApiResponse<T_HlReportingServiceApiPayload>,
      T_HlReportingServiceApiRequest
    >({
      query: (payload) => ({
        url: Api_ReportingService,
        method: "POST",
        body: payload,
      }),
    }),
    createCase: builder.query<T_ApiResponse<T_CaseDetails>, CustomerRequest>({
      query: (payload) => ({
        url: Api_CreateCase,
        method: "POST",
        body: payload,
      }),
    }),
    reportingService: builder.query<
      T_ApiResponse<T_ReportingServiceResponse>,
      T_ReportingService_RequestData
    >({
      query: (payload) => ({
        url: Api_ReportingService,
        method: "POST",
        body: payload,
      }),
    }),
    welcomeKitService: builder.query<
      T_ApiResponse<T_WelcomeKitDownloadResponse>,
      T_ReportingService_RequestData
    >({
      query: (serviceReq) => ({
        url: Api_WelcomeKitService,
        method: "POST",
        body: serviceReq,
      }),
    }),
    submitCaseRequest: builder.query<
      T_ApiResponse<T_CaseCreateResponse>,
      T_CaseCreateRequest
    >({
      query: (reqPayload) => ({
        url: Api_CreateCase,
        method: "POST",
        body: reqPayload,
      }),
    }),
    createPaymentOrder: builder.query<
      T_ApiResponse<T_CreateOrderResponse>,
      T_CreateOrderRequest
    >({
      query: (reqPayload) => ({
        url: Api_Create_Order,
        method: "POST",
        body: reqPayload,
      }),
    }),
    fetchOrderStatus: builder.query<
      T_ApiResponse<T_OrderStatusResponse>,
      T_OrderStatusRequest
    >({
      query: (reqPayload) => ({
        url: Api_Order_Status,
        method: "POST",
        body: reqPayload,
        headers: {
          "pl-timestamp": dayjs().format("YYYYMMDDHHMMss"),
          "pl-traceid": nanoid(8),
          "pl-merc-id": reqPayload.merc_id,
        },
      }),
    }),
    fetchCreateCaseQuery: builder.query<
      T_ApiResponse<T_HlServiceRequestResponse>,
      T_HlCreateCaseQueryRequest
    >({
      query: (reqPayload) => ({
        url: Api_Create_Case_Query,
        method: "POST",
        body: reqPayload,
      }),
    }),
    changeEmailMobile: builder.query<
      T_ApiResponse<T_EmailChangeResponse>,
      T_EmailChangeRequest
    >({
      query: (payload) => ({
        url: Api_ChangeEmail,
        method: "POST",
        body: payload,
      }),
    }),
    fetchCreateCaseQueryMultiple: builder.query<
      T_ApiResponse<T_HlServiceRequestResponse[]>,
      T_HlCreateCaseQueryMultipleRequest
    >({
      query: (reqPayload) => ({
        url: Api_Create_Case_Query_Multiple,
        method: "POST",
        body: reqPayload,
      }),
    }),
    fetchHlCustomerInfo: builder.query<
      T_ApiResponse<T_HlCustomerInfoResponse>,
      T_HlCustomerInfoRequest
    >({
      query: (reqPayload) => ({
        url: Api_Customer_Info,
        method: "POST",
        body: reqPayload,
      }),
    }),
    fetchHLFeatureEmailCount: builder.query<
      T_ApiResponse<T_FetchHLEmailCount_Response>,
      T_FetchHLEmailCount_Request
    >({
      query: (reqPayload) => ({
        url: Api_FetchHLEmailCount,
        method: "POST",
        body: reqPayload,
      }),
    }),
    saveHomeLoanFaqDetails: builder.query<
      T_ApiResponse<T_SaveHomeLoanFaqDetails_Response>,
      T_SaveHomeLoanFaqDetails_Request
    >({
      query: (payload) => ({
        url: Api_CreateCase,
        method: "POST",
        body: payload,
      }),
    }),
    fetchHLAdvanceEMIPayment: builder.query<
      T_ApiResponse<T_AdvanceEMIPaymentDetail_Response>,
      T_AdvanceEMIPaymentDetail_Request
    >({
      query: (reqPayload) => ({
        url: Api_FetchHLAdvanceEMI_Payment_Detail,
        method: "POST",
        body: reqPayload,
      }),
    }),
    fetchHLRoiHistory: builder.query<
      T_ApiResponse<T_FetchHLRoiHistory_Response>,
      T_FetchHLRoiHistory_Request
    >({
      query: (reqPayload) => ({
        url: Api_FetchHLRoiHistory,
        method: "POST",
        body: reqPayload,
      }),
    }),
    CreateCaseRoiHistory: builder.query<
      T_ApiResponse<T_CreateCaseRoiHistory_Response>,
      T_CreateCaseRoiHistory_Request
    >({
      query: (reqPayload) => ({
        url: Api_CreateCase,
        method: "POST",
        body: reqPayload,
      }),
    }),
    hflGenerateOtpService: builder.query<
      T_ApiResponse<T_HFL_Otp_Service_Response>,
      T_HFL_Generate_Otp_Request
    >({
      query: (reqPayload) => ({
        url: Api_HomeLoan_Generate_Otp,
        method: "POST",
        body: reqPayload,
      }),
    }),
    hflValidateOtpService: builder.query<
      T_ApiResponse<T_HFL_Otp_Service_Response>,
      T_HFL_Validate_Otp_Request
    >({
      query: (reqPayload) => ({
        url: Api_HomeLoan_Validate_Otp,
        method: "POST",
        body: reqPayload,
      }),
    }),
    fetchPDDInformation: builder.query<
      T_ApiResponse<T_FetchPDDInformation_Response>,
      T_FetchPDDInformation_Request
    >({
      query: (reqPayload) => ({
        url: Api_Fetch_PDD_Information,
        method: "POST",
        body: reqPayload,
      }),
    }),
    createCasePdd: builder.query<
      T_ApiResponse<T_CreateCasePdd_Response>,
      T_CreateCasePdd_Request
    >({
      query: (reqPayload) => ({
        url: Api_CreateCase,
        method: "POST",
        body: reqPayload,
      }),
    }),
    fetchHomeLoanIdentifier: builder.query<
      T_ApiResponse<T_Fetch_HomeLoanIdentifier_Response>,
      T_Fetch_HomeLoanIdentifier_Request
    >({
      query: (payload) => ({
        method: "POST",
        url: HomeLoanIdentifier,
        body: payload,
      }),
    }),
    createCaseReKyc: builder.query<
      T_ApiResponse<T_CreateCaseReKyc_Response>,
      T_CreateCaseReKyc_Request
    >({
      query: (payload) => ({
        url: Api_CreateCase,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyCreateCaseQuery,
  useLazyReportingServiceQuery,
  useLazyWelcomeKitServiceQuery,
  useLazyCreatePaymentOrderQuery,
  useLazySubmitCaseRequestQuery,
  useLazyFetchOrderStatusQuery,
  useLazyGetCreateCaseDetailsQuery,
  useLazyCreateCaseAPIQuery,
  useLazyGetReportingServiceDetailsQuery,
  useLazyFetchDataServiceDetailsQuery,
  useLazyFetchLanDetailsQuery,
  useLazyFetchCreateCaseQueryQuery,
  useLazyFetchCreateCaseQueryMultipleQuery,
  useLazyChangeEmailMobileQuery,
  useLazyFetchHlCustomerInfoQuery,
  useLazyFetchHLFeatureEmailCountQuery,
  useLazySaveHomeLoanFaqDetailsQuery,
  useLazyFetchHLAdvanceEMIPaymentQuery,
  useLazyFetchHLRoiHistoryQuery,
  useLazyCreateCaseRoiHistoryQuery,
  useLazyHflGenerateOtpServiceQuery,
  useLazyHflValidateOtpServiceQuery,
  useLazyFetchPDDInformationQuery,
  useLazyCreateCasePddQuery,
  useLazyFetchHomeLoanIdentifierQuery,
  useLazyCreateCaseReKycQuery,
} = HomeloanApi;
